(function () {
  // Update variant title on variant change
  document.addEventListener("variant:change", (event) => {
    let variantTitleElem = document.querySelectorAll("[data-variant-title]");

    if (!variantTitleElem.length) {
      return;
    }

    variantTitleElem.forEach(
      (item) => (item.innerHTML = event.detail.variant.title)
    );
  });
})();

(function () {
  // Delegate sticky add to cart button
  let addToCart = document.querySelectorAll("[data-sticky-add-to-cart]");

  if (!addToCart.length) {
    return;
  }

  addToCart.forEach((button) => {
    button.addEventListener("click", () => {
      let primaryAddToCart = document.querySelector("[data-add-to-cart]");

      if (!primaryAddToCart) {
        return;
      }

      primaryAddToCart.click();
    });
  });
})();

(function () {
  let smoothScrollElem = document.querySelectorAll('a[href*="#"]');

  if (!smoothScrollElem.length) {
    return;
  }

  smoothScrollElem.forEach((anchor) => {
    if (
      anchor.closest(".faqs-grouped") ||
      anchor.closest(".collections-navbar")
    ) {
      return;
    }

    if (
      location.pathname.replace(/^\//, "") !=
        anchor.pathname.replace(/^\//, "") ||
      location.hostname != anchor.hostname
    ) {
      return;
    }

    anchor.addEventListener("click", (event) => {
      event.preventDefault();
      let offset = 0;
      let hash = anchor.hash;

      if (hash !== "#") {
        let target = document.getElementById(hash.substring(1));

        if (target) {
          let header = document.getElementById("SiteHeader");
          let productStickyNav = document.querySelector(
            "[data-product-sticky-nav]"
          );

          offset += target.offsetTop;

          if (header && header.dataset.sticky == "true") {
            offset -= header.offsetHeight;
          }

          if (productStickyNav) {
            offset -= productStickyNav.offsetHeight;
          }
        }
      }

      $("html, body").animate(
        {
          scrollTop: offset,
        },
        500
      );
    });
  });
})();

(function () {
  let header = document.getElementById("SiteHeader");
  let offset = 0;

  if (header && header.dataset.sticky == "true") {
    offset = header.offsetHeight;
  }

  // TODO: It'd be better to use a JS library
  $(".product-sticky-nav").stick_in_parent({
    parent: "#MainContent",
    offset_top: offset,
  });
})();

(function () {
  function headerHeight() {
    if (
      !document
        .getElementsByClassName("main-content")[0]
        .firstElementChild.classList.contains("hero-section")
    ) {
      let headerHeight =
        document.getElementsByClassName("site-header")[0].offsetHeight;
      document
        .getElementsByClassName("main-content")[0]
        .classList.add("page-without-hero");
      document.getElementsByClassName("main-content")[0].style.marginTop =
        headerHeight + "px";
    }
  }

  headerHeight();
  window.onresize = headerHeight;
})();

(function () {
  var collectionsNav = document.querySelectorAll(".collections-navbar a");

  if (!collectionsNav) {
    return;
  }

  function collectionFilter(currentCollection) {
    document
        .querySelectorAll("#CollectionFilter .grid__item")
        .forEach((item) => (item.style.display = "none"));

    document
      .querySelectorAll("#CollectionFilter .grid__item")
      .forEach((item) => {
        var collections = item.dataset.collections;
        collections
          .split(",")
          .filter((n) => n)
          .forEach((collection) => {
            if (currentCollection == collection.toLowerCase() || currentCollection == 'all-products') {
              item.style.display = "flex";
            }
          });
      });
  }

  collectionsNav.forEach((anchor) => {
    if (anchor.classList.contains('active')) {
      collectionFilter(anchor.dataset.collection);
    }

    anchor.addEventListener("click", (el) => {
      anchor
        .closest(".collections-navbar")
        .querySelectorAll("a")
        .forEach((i) => i.classList.remove("active"));
      anchor.classList.add("active");

      var currentCollection = anchor.dataset.collection;
      collectionFilter(currentCollection);
    });
  });
})();

(function () {
  var featuredCollection = document.querySelectorAll('.featured-collection');
  if (!featuredCollection) {
    return;
  }

  featuredCollection.forEach(el => {
    let sectionID = el.getAttribute('data-section-id');

    let featuredProductsSlider = document.getElementById('featured-products-slider-'+sectionID);

    var options = {
      adaptiveHeight: false,
      wrapAround: true,
      avoidReflow: true,
      fade: false,
      pageDots: true,
      prevNextButtons: true,
      percentPosition: false,
      cellAlign: 'left',
      groupCells: 3
    };

    if ( matchMedia('screen and (max-width: 1199px)').matches ) {
      options.groupCells = 2;
    }

    if ( matchMedia('screen and (max-width: 767px)').matches ) {
      options.groupCells = false;
    }

    if ( matchMedia('screen and (max-width: 589px)').matches ) {
      options.adaptiveHeight = true;
    }

    var flktyfeaturedProductsSlider = new Flickity(featuredProductsSlider, options);
  });

})();

(function () {
  var orderNoteToggler = document.querySelectorAll('.order-note-toggler');

  if (!orderNoteToggler) {
    return;
  }

  orderNoteToggler.forEach(function (el) {
    el.addEventListener('click', function (el) {
      el.target.classList.toggle('checked');
      var orderNoteField = el.target.closest('.cart__checkout-wrapper').querySelector('.order-note-field');
      if (el.target.classList.contains('checked')) {
        orderNoteField.classList.remove('hide');
      } else {
        orderNoteField.classList.add('hide');
      }
    })
  });
})();
